export default "/assets/images/skin.svg?f64c3af3d0d25b9e4e003a8c03e4f70a";